const DEFAULT_SLOT_NAMES = {
  planA: 'Plan A',
  planB: 'Plan B',
  planC: 'Plan C',
  planD: 'Plan D',
}

const CLEAR_SLOT_NAMES = {
  planA: 'Current Plan',
  planB: 'Option 2',
  planC: 'Option 3',
  planD: 'Option 4',
}

// The store and export formats keep their long-standing Plan A-D names for
// compatibility. Only untouched default names are translated for the UI;
// anything the user renamed is shown exactly as saved.
export function planDisplayName(planKey, storedName) {
  const name = String(storedName || '').trim()
  if (!name || name === DEFAULT_SLOT_NAMES[planKey]) {
    return CLEAR_SLOT_NAMES[planKey] || name || 'Plan Option'
  }
  return name
}

export function baselineDisplayName(storedName) {
  return planDisplayName('planA', storedName)
}
